import { FadeUp, SectionLabel } from "./Reveal";
import { RESUME } from "../data/resume";
import { useLang } from "../lib/lang";

const Block = ({ title, children }) => (
  <FadeUp className="border-t border-white/10 pt-6">
    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{title}</h3>
    <div className="mt-4">{children}</div>
  </FadeUp>
);

export const Resume = () => {
  const { tr } = useLang();
  return (
    <section id="resume" data-testid="resume-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionLabel index="06">Resume</SectionLabel>
      <div className="mt-8 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <FadeUp as="h2" className="font-display text-5xl font-semibold uppercase leading-[0.95] tracking-tight sm:text-6xl">
            {tr({ es: "Trayectoria", en: "Experience" })}<span className="font-serif-i normal-case text-[var(--acid)]">.</span>
          </FadeUp>
          <FadeUp delay={0.1} className="mt-6 text-zinc-300">{tr(RESUME.summary)}</FadeUp>
        </div>
        <div className="lg:col-span-8">
          {RESUME.jobs.map((j, i) => (
            <FadeUp key={j.co} delay={i * 0.04} className="group grid gap-3 border-t border-white/10 py-7 sm:grid-cols-[1fr_2fr]">
              <div>
                <p className="font-mono text-xs text-[var(--acid)]">{tr(j.years)}</p>
                <h3 data-testid={`resume-job-${i}`} className="mt-2 font-display text-2xl font-medium transition-colors group-hover:text-[var(--acid)]">{j.co}</h3>
                <p className="text-sm text-zinc-400">{tr(j.place)}</p>
              </div>
              <div>
                <p className="font-medium text-white">{tr(j.role)}</p>
                <ul className="mt-3 space-y-2">
                  {tr(j.points).map((p) => <li key={p} className="flex gap-3 text-sm text-zinc-300"><span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[var(--acid)]" />{p}</li>)}
                </ul>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
      <div className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <Block title={tr({ es: "Educación", en: "Education" })}><p className="text-zinc-200">{tr(RESUME.education)}</p></Block>
        <Block title={tr({ es: "Logros", en: "Achievements" })}><p className="text-zinc-200">{tr(RESUME.achievement)}</p></Block>
        <Block title={tr({ es: "Idiomas", en: "Languages" })}>
          {RESUME.languages.map((x) => <p key={x.l.es} className="flex justify-between border-b border-white/5 py-1.5 text-zinc-200"><span>{tr(x.l)}</span><span className="text-zinc-400">{tr(x.v)}</span></p>)}
        </Block>
        <Block title={tr({ es: "Habilidades y cursos", en: "Skills & courses" })}>
          <div className="flex flex-wrap gap-2">{RESUME.skills.map((s) => <span key={s} className="rounded-full border border-white/15 px-3 py-1 text-xs text-zinc-300">{s}</span>)}</div>
          <ul className="mt-4 space-y-1 text-xs text-zinc-400">{RESUME.courses.map((c) => <li key={c}>{c}</li>)}</ul>
        </Block>
      </div>
    </section>
  );
};
